module.exports = __webpack_public_path__ + "d3c896d8913ecd1deb14b10876c25a50.png";